// @flow

import { location } from 'window';
import url from 'url';

import Cookies from 'js-cookie';
import UUID from 'uuid-js';

const COOKIE_NAME = 'session-id';

/**
 * Returns domain for the cookie used to store sessionid
 *
 * @param {string} locationHref page url you want to figure sessionid cookie domain for
 * @returns {string} domain for sessionid cookie
 * @private exported only for tests
 */
export const __getSessionCookieDomain = (locationHref: string): string => {
	const locationHostname = url.parse(locationHref).hostname || '';
	const hostnameParts = locationHostname.split('.');
	if (hostnameParts.includes('rgs-dev')) {
		return hostnameParts.slice(-6).join('.');
	}
	return hostnameParts.slice(-2).join('.');
};

export const create: () => string = () => {
	return UUID.create().hex;
};

export const sessionId: () => string = () => {
	let sid = Cookies.get(COOKIE_NAME);

	if (sid) {
		return sid;
	}

	sid = create();

	const domain = __getSessionCookieDomain(location.href);
	Cookies.set(COOKIE_NAME, sid, { domain, expires: 365 * 10 });

	return sid;
};

export const reset: () => void = () => {
	const domain = __getSessionCookieDomain(location.href);
	Cookies.remove(COOKIE_NAME, { domain });
};
